import router from '@/router'
import bankingRoute from './banking/banking.routes'
import staticBankingRoute from './static-banking/static-banking.routes'
import { AppSidebar, AppHeader } from '@/components'

export default () => {
  router.addRoute({
    path: '/savings',
    name: 'savings',
    components: {
      default: () => import('./savings.vue'),
      sidebar: AppSidebar,
      header: AppHeader
    },
    children: [bankingRoute, staticBankingRoute]
  })
  router.addRoute({
    path: '/savings/services/overdraft-fees',
    name: 'overdraft-fees',
    component: () => import('./services/overdraftFees/overdraftFees.vue'),
    meta: {
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    }
  })
}
